import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'array-field',
  shadow: false,
})
export class ArrayField {
  // Propiedades del componente
  @Prop() name: string;
  @Prop() items: any[];

  // Método para renderizar el componente
  render() {
    console.log('ArrayField', { name: this.name, items: this.items });
    return (
      <div class="array-field">
        <ul>
          {this.items.map(item => (
            <li>{item}</li>
          ))}
        </ul>
      </div>
    );
  }
}
